var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"普通","headers":_vm.indicateHeaders,"items":_vm.items,"item_class":_vm.indicateRowBackground},on:{"makenew":_vm.toNormalEdit,"repair":_vm.toNormalEditRepair,"copy":_vm.toNormalEditCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }